import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  ReactNode,
  isValidElement,
  cloneElement,
  Children
} from "react";

const FileInputWrapper = ({ inputElement }) => {
  const [fileName, setFileName] = useState('Choose File');

  const handleChange = (e) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      setFileName(files[0].name);
    } else {
      setFileName('Choose File');
    }

    if (inputElement.props.onChange) {
      inputElement.props.onChange(e);
    }
  };

  const clonedInput = cloneElement(inputElement, {
    value: undefined,
    onChange: handleChange,
  });

  return (
    <label className="file-upload-wrapper">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M13.999 10V12.6664C13.999 13.02 13.8585 13.3591 13.6085 13.6092C13.3584 13.8592 13.0193 13.9997 12.6657 13.9997H3.33322C2.97963 13.9997 2.64052 13.8592 2.39049 13.6092C2.14046 13.3591 2 13.02 2 12.6664V10" stroke="#99A1AF" strokeWidth="1.33322" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M11.3321 5.33304L7.99906 2L4.66602 5.33304" stroke="#99A1AF" strokeWidth="1.33322" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M7.99902 2V9.9993" stroke="#99A1AF" strokeWidth="1.33322" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
      <span>
        {fileName}
      </span>
      {clonedInput}
    </label>
  );
};

const Dialog = forwardRef(({ children, closeOnBackdropClick, transparentBg, onClose, outsideButtons, title, subtitle }, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    show: () => setOpen(true),
    hide: () => setOpen(false),
    toggle: () => setOpen((prev) => !prev),
  }));

  function wrapFileInputs(children) {
    return Children.map(children, (child, index) => {
      if (!isValidElement(child)) return child;

      if (child.type === 'input' && child.props.type === 'file') {
        return <FileInputWrapper key={child.key || `file-input-${index}`} inputElement={child} />;
      }

      if (child.props && child.props.children) {
        return cloneElement(child, {
          children: wrapFileInputs(child.props.children)
        });
      }

      return child;
    });
  }

  return (
    <div className={`dialog-container ${open ? 'open' : ''}`} onClick={(e) => {
        if (closeOnBackdropClick && e.target === e.currentTarget) {
            setOpen(false);
            if (typeof onClose == 'function') onClose();
        }
    }}>
      <div>
        <div className={`${transparentBg ? 'transparent-bg' : ''} p-0 dialog-content-wrapper content-box`}>
          <div className="dialog-close-button" onClick={() => {
            setOpen(false);
            if (typeof onClose == 'function') onClose();
          }}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          {!!title && (
            <div className="dialog-content-title">
              <div className="title">
                {title}
              </div>
              {subtitle && (
                <div className="subtitle">
                  {subtitle}
                </div>
              )}
            </div>
          )}
          <div className={`dialog-content-body`}>
            {wrapFileInputs(children)}
          </div>
          {!!outsideButtons && (
            <div className="dialog-content-buttons">
              {outsideButtons}
            </div>
          )}
        </div>
        {/*<div style={{all: 'unset', marginTop: 5, display: 'block'}}>{outsideButtons}</div>*/}
      </div>
    </div>
  );
});

Dialog.displayName = "Dialog";

export default Dialog;